// @ utilities
const Storage = require('utilities/storage');
const apiURLBuilder = require('core/apiURLBuilder');
const { get } = require('services/api');
const Api = require('../services/api');
import { formatText } from 'core/i18n';
// @ constants
const actionTypes = require('constants/RAConstants/actionTypes');
const { CONTRIBUTION_PERIOD_MONTHLY } = require('constants/RAConstants');
// @actions
const preLoaderActions = require('./preLoaderActions');
const raCustomPlanByObjective = require('actions/RACustomPlanByObjective');
const raSetGoalActions = require('actions/RASetGoal');

const requestSimulationInProgress = () => ({
    type: actionTypes.RA_SIMULATION_REQUEST,
});

const requestSimulationSuccess = response => ({
    type: actionTypes.RA_SIMULATION_REQUEST_SUCCESS,
    payload: response,
});

const requestSimulationFailure = () => ({
    type: actionTypes.RA_SIMULATION_REQUEST_FAILURE,
});

const saveSimulationInProgress = () => ({
    type: actionTypes.RA_SIMULATION_SAVE,
});

const saveSimulationSuccess = response => ({
    type: actionTypes.RA_SIMULATION_SAVE_SUCCESS,
    payload: response,
});

const saveSimulationFailure = () => ({
    type: actionTypes.RA_SIMULATION_SAVE_FAILURE,
});

const updateSimulation = update => ({
    type: actionTypes.RA_SIMULATION_UPDATE_SIMULATION,
    payload: update,
});

const requestSimulation =
    (pureRobo = false) =>
    (dispatch, getState) => {
        // TODO: remove cookie auth token when endpoint is available on onb
        const openBankToken = Storage.cookies.get('openBankToken');

        const requestData = {
            header: {
                openbankAuthToken: openBankToken,
                version: 2,
            },
            query: {
                pureRobo: pureRobo,
            },
        };

        dispatch(requestSimulationInProgress());
        return get(apiURLBuilder.getURL('raSimulation'), requestData)
            .then(response => {
                if (response) {
                    dispatch(requestSimulationSuccess(response.body));
                    if (!pureRobo) {
                        dispatch(raCustomPlanByObjective.getSimulation());
                        dispatch(raSetGoalActions.updateGoalFromSimulation(response.body));
                    }
                } else {
                    if (!pureRobo) {
                        const userProfile = getState().userProfile;
                        dispatch(preLoaderActions.showPreLoader());
                        dispatch(raSetGoalActions.getGoalOnboarding(userProfile.accessToken));
                    }
                    dispatch(requestSimulationFailure());
                }
                dispatch(preLoaderActions.hidePreLoader());
            })
            .catch(() => {
                if (!pureRobo) {
                    const userProfile = getState().userProfile;
                    dispatch(raSetGoalActions.getGoalOnboarding(userProfile.accessToken));
                }
                dispatch(preLoaderActions.hidePreLoader());
                dispatch(requestSimulationFailure());
            });
    };

const saveSimulationService = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('raSimulation'), requestData)
        .then(response => {
            dispatch(saveSimulationSuccess(response));
            callback(true);
        })
        .catch(error => {
            callback(false);
            dispatch(preLoaderActions.hidePreLoader());
            if (error.error) {
                dispatch(saveSimulationFailure(error.error.description));
            } else {
                dispatch(saveSimulationFailure());
            }
        });
};

const saveSimulation =
    (accessToken, callback, gbi = false) =>
    (dispatch, getState) => {
        const immCustomPlanByObjective = getState().raCustomPlanByObjective;
        const immManagementPlan = getState().raManagementPlan;
        const immSimulation = gbi ? immCustomPlanByObjective : immManagementPlan;
        const immTimeHorizonCheck = getState().raTimeHorizonCheck;

        const amount = immCustomPlanByObjective.get('objectiveAmount') || undefined;
        const endDate = immCustomPlanByObjective.get('objectiveEndDate') || undefined;
        const type =
            immCustomPlanByObjective.get('objectiveType') &&
            immCustomPlanByObjective.get('objectiveType').toUpperCase();
        const initialContribution = immSimulation.get('initialContributionAmount') || undefined;
        const name = immCustomPlanByObjective.get('objective');
        const selectedPortfolio = gbi
            ? immCustomPlanByObjective.get('selectedStrategy')
            : immManagementPlan.get('investProfileValue');
        const hasRecurringTransfer = gbi ? true : immManagementPlan.get('hasRecurringContribution') ? true : false;
        const periodicity = immSimulation.get('periodicity');
        const recurringContributionDay = immSimulation.get('recurringContributionDay');
        let cutDay = 0;
        cutDay = periodicity === CONTRIBUTION_PERIOD_MONTHLY ? recurringContributionDay : 1;
        const recurringTransfer =
            hasRecurringTransfer && immSimulation.get('recurringContributionAmount') > 0
                ? {
                      amount: immSimulation.get('recurringContributionAmount'),
                      cutDay: cutDay,
                      frequencyCode: periodicity,
                  }
                : undefined;
        const maxTypeOfProduct = immTimeHorizonCheck.get('maxTypeOfProduct');
        const displayName = formatText(`raStrategyItem-raStrategyItem_${selectedPortfolio}`);

        const update = {
            amount,
            currency: 'EUR',
            endDate,
            hasRecurringTransfer,
            maxTypeOfProduct,
            initialContribution,
            name,
            recurringTransfer,
            selectedPortfolio,
            type,
            displayName,
        };

        dispatch(saveSimulationInProgress());
        dispatch(updateSimulation(update));

        const simulation = getState().raSimulation.get('simulation').toJS();
        simulation.pureRobo = !gbi;

        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: simulation,
        };

        saveSimulationService(dispatch, requestData, callback);
    };

const sendOkSimulationService = (dispatch, requestData, callback) => {
    Api.post(apiURLBuilder.getURL('simulationOk'), requestData)
        .then(response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true);
            } else {
                callback(false);
            }
        })
        .catch(() => {
            callback(false);
        });
};

const sendOkSimulation = (accessToken, callback) => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: 'Bearer ' + accessToken,
            },
            query: {},
        };
        sendOkSimulationService(dispatch, requestData, callback);
    };
};

export default {
    requestSimulation,
    saveSimulationInProgress,
    saveSimulationSuccess,
    saveSimulationFailure,
    updateSimulation,
    sendOkSimulation,
    saveSimulation,
};
